import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState({}); // To store items for each category

  useEffect(() => {
    const apiKey = process.env.REACT_APP_API_KEY;

    const fetchCategories = async () => {
      try {
        const response = await fetch('https://kmatadmin.worldpos.biz/Api/CategoryMain', {
          headers: {
            'APIKey': apiKey,
          },
        });
        const data = await response.json();
        if (data.success) {
          setCategories(data.data);
          // Fetch items for all categories after fetching categories
          fetchItemsForCategories(data.data);
        } else {
          console.error('Error fetching categories:', data.errorMessage);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    };

    const fetchItemsForCategories = async (categories) => {
      const newItems = {};
      try {
        await Promise.all(
          categories.map(async (category) => {
            const response = await fetch(`https://kmatadmin.worldpos.biz/Api/CategorySub?CategoryMainID=${category.categoryMainID}`, {
              headers: {
                'APIKey': apiKey,
              },
            });
            const data = await response.json();
            if (data.success) {
              newItems[category.categoryMainID] = data.data;
            } else {
              console.error('Error fetching items for category:', category.categoryMainID, data.errorMessage);
            }
          })
        );
        setItems(newItems);
      } catch (error) {
        console.error('Fetch error:', error);
      }
    };

    fetchCategories();
  }, []);

  return (
<div id='categories' className='w-full bg-cyan-950'>
  <div className='w-[90%] py-2 mx-auto mt-20 2lg:mt-14 3lg:mt-20 flex flex-wrap justify-center gap-5 sm:gap-7 md:gap-8 lg:gap-10 items-center'>
    {categories.map((category) => (
      <div key={category.categoryMainID} className='relative group'>
        <ScrollLink 
          to={category.categoryMainName} 
          smooth={true} 
          duration={500} 
          offset={-100}
        >
          <h1 className='font-semibold uppercase cursor-pointer text-white font-overpass text-[16px] 2lg:text-[14px] 3lg:text-[16px]'>
            {category.categoryMainName}
          </h1>
        </ScrollLink>
        <div className='w-[300px] hidden lg:block z-20 py-5 translate-y-4 group-hover:translate-y-0 duration-500 opacity-0 group-hover:opacity-100 bg-white absolute -left-28 border invisible group-hover:visible'>
          <ul className='w-full h-full space-y-3 flex flex-col justify-center'>
            {items[category.categoryMainID]?.length > 0 ? (
              items[category.categoryMainID].map((item) => (
                <ScrollLink 
                  to={item.categorySubID} 
                  smooth={true} 
                  duration={500} 
                  offset={-100}
                  className='text-cyan-700 cursor-pointer text-sm font-karla hover:text-cyan-600/80 w-[80%] mx-auto'
                >
                  {item.categorySubName}
                </ScrollLink>
              ))
            ) : (
              <li className='text-red-600 text-center'>No items available</li>
            )}
          </ul>
        </div>
      </div>
    ))}
  </div>
</div>
  );
};

export default Categories;
